import React from "react";
import {Link} from "react-router-dom";
import {Button, Card, Tag, Typography} from "antd";
import {ArrowLeftOutlined, FireOutlined} from "@ant-design/icons";

const { Title, Text } = Typography;

function CampaignTemp() {
    return (
        <Link to="/student/lessons/take?grade_id=14&topic_id=&classroom_id=">
            <Card
                bordered={false}
                className="
                    group
                    relative
                    overflow-hidden
                    rounded-[28px]
                    border-0
                    bg-gradient-to-br
                    from-sky-500
                    via-blue-600
                    to-indigo-700
                    shadow-[0_20px_60px_rgba(30,64,175,0.35)]
                    transition-all
                    duration-500
                    hover:-translate-y-2
                    hover:shadow-[0_30px_80px_rgba(30,64,175,0.55)]
                "
                bodyStyle={{ padding: 32 }}
            >
                {/* Background Glow */}
                <div className="absolute -top-20 -left-20 h-60 w-60 rounded-full bg-white/10 blur-3xl" />
                <div className="absolute -bottom-24 -right-16 h-72 w-72 rounded-full bg-cyan-300/20 blur-3xl" />

                {/* Pattern */}
                <div
                    className="absolute inset-0 opacity-10"
                    style={{
                        backgroundImage:
                            "radial-gradient(circle at 2px 2px, white 1px, transparent 0)",
                        backgroundSize: "28px 28px",
                    }}
                />

                <div className="relative flex flex-col-reverse items-center gap-10 lg:flex-row lg:justify-between">

                    {/* Text */}
                    <div className="flex-1 text-center lg:text-right">

                        <Tag
                            color="gold"
                            icon={<FireOutlined />}
                            className="mb-5 rounded-full px-4 py-1 text-sm"
                        >
                            پویش ملی حفظ سوره فتح
                        </Tag>

                        <Title
                            level={2}
                            className="!mb-4 !leading-[1.8] !text-white flex flex-wrap"
                        >
                            جهت شرکت در پویش ملی

                            <span className="mx-2 rounded-xl bg-white px-3 py-1 text-4xl font-black text-blue-700 shadow-lg">
                                {' '}
                                به نام پیروزی
                                {' '}

                            </span>
                            {' '}
                            کلیک کنید
                        </Title>

                        <Text className="block text-lg text-blue-100">
                            حفظ سوره مبارکه فتح همراه با مسابقه، جوایز و
                            گواهی شرکت در پویش
                        </Text>

                        <Button
                            type="primary"
                            size="large"
                            icon={<ArrowLeftOutlined />}
                            className="
                                mt-8
                                h-12
                                font-bold
                                rounded-full
                                border-0
                                bg-white
                                px-8
                                !text-blue-700
                                shadow-xl
                                transition-all
                                hover:scale-105
                                hover:!bg-blue-50
                            "
                        >
                            شرکت در پویش
                        </Button>
                    </div>

                    {/* Image */}
                    <div className="relative">

                        <div className="absolute inset-0 rounded-full bg-white/30 blur-3xl" />

                        <div
                            className="
                                relative
                                h-[230px]
                                w-[230px]
                                overflow-hidden
                                rounded-3xl
                                border
                                border-white/30
                                bg-white/10
                                backdrop-blur-md
                                shadow-2xl
                                transition-all
                                duration-500
                                group-hover:rotate-3
                                group-hover:scale-105
                            "
                        >
                            <img
                                src="/images/campaign/sore-fath.png"
                                alt="سوره فتح"
                                className="h-full w-full object-fill"
                            />
                        </div>

                    </div>
                </div>
            </Card>
        </Link>
    );
}

export default CampaignTemp;